<template>
  <div>
    <ocpc type="setting" />
  </div>
</template>
<script>
import Ocpc from './components/OcpcMain'
export default {
  components: {
    Ocpc
  }
}
</script>
